import React from 'react'

import { AIGeneratedGradientFilled } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'

import { buildLocalizedPath } from 'Utils/getLocalizedUrl'

function buildAiModeHref(value, locale) {
  const params = new URLSearchParams({ mode: 'text-to-3d' })
  const prompt = value?.trim()

  if (prompt) {
    params.set('prompt', prompt)
  }

  return buildLocalizedPath(`/ai?${params.toString()}`, locale)
}

function AiModeButton({ value = '', locale = 'en' }) {
  const label = i18n.t('search.aiMode', { ns: 'new-home', lng: locale })

  return (
    <a
      className="new-search__ai-mode"
      href={buildAiModeHref(value, locale)}
      data-track="ai-mode-click"
      data-content-type="ai-mode"
    >
      <AIGeneratedGradientFilled width="20" height="20" className="new-search__ai-mode-icon" />
      <span className="new-search__ai-mode-label">{label}</span>
    </a>
  )
}

AiModeButton.propTypes = {
  value: string,
  locale: string,
}

export default AiModeButton
